import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "card mb-xl-3",
  id: "kt_profile_details_view"
}
const _hoisted_2 = { class: "cursor-pointer text-dark" }
const _hoisted_3 = { class: "p-5" }
const _hoisted_4 = { class: "row gy-1 g-xl-12" }
const _hoisted_5 = { class: "d-flex justify-content-between col-xxl-7" }
const _hoisted_6 = { class: "row fv-row" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-5 mb-3" }, "Budget Type", -1)
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "row fv-row" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-5" }, "Report Type", -1)
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "row fv-row" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-5" }, "Scenario Type", -1)
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "d-flex col-xxl-5 pt-8" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("button", {
  class: "\n                  text-white\n                  btn-sm btn-active-light-primary\n                  me-2\n                  btn-primary\n                ",
  "data-kt-menu-dismiss": "true"
}, " Dashboard ", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("button", {
  class: "\n                  text-white\n                  btn-sm btn-active-light-primary\n                  me-2\n                  btn-primary\n                ",
  "data-kt-menu-dismiss": "true"
}, " Position Data Table ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _withDirectives(_createElementVNode("select", {
                  class: "form-select form-select-solid",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.config.flexibleProcurement.current = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.budgetType, (budget, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: index,
                      value: budget.id
                    }, _toDisplayString(budget.name), 9, _hoisted_8))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.config.flexibleProcurement.current]
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _withDirectives(_createElementVNode("select", {
                  class: "form-select form-select-solid",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.config.flexibleProcurement.reportName = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportType, (report, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: index,
                      value: report.id
                    }, _toDisplayString(report.name), 9, _hoisted_11))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.config.flexibleProcurement.reportName]
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _withDirectives(_createElementVNode("select", {
                  class: "form-select form-select-solid",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.config.flexibleProcurement.scenarioName = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenarioType, (scenario, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: index,
                      value: scenario.id
                    }, _toDisplayString(scenario.name), 9, _hoisted_14))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.config.flexibleProcurement.scenarioName]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_router_link, {
                to: "/FlexibleProcurement/PositionReportDashboard",
                class: "router-link-active"
              }, {
                default: _withCtx(() => [
                  _hoisted_16
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: "/FlexibleProcurement/PositionDataTable",
                class: "router-link-active"
              }, {
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: "/FlexibleProcurement/PositionReportDashboard3",
                class: "router-link-active"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    type: "submit",
                    class: "\n                  text-white\n                  btn-sm btn-active-light-primary\n                  me-2\n                  btn-primary\n                ",
                    "data-kt-menu-dismiss": "true",
                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.downloadItem()), ["prevent"]))
                  }, " Download Report ")
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_router_view)
  ], 64))
}